/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

import { formatPhoneNumber } from '../../../utils/formater';

const AddressHelper = ({ address = {}, phone = {} }) => {
    const {
        businessName,
        addressLine1,
        addressLine2,
        cityName,
        state,
        zipcode,
        countryCode,
    } = address;
    return (
        <>
            <div className="productInfo">
                {businessName}
            </div>
            <div className="productInfo">
                {addressLine1}
                {addressLine2 ? `, ${addressLine2}` : ''}
            </div>
            <div className="productInfo">
                {cityName}, {state}, {zipcode}
            </div>
            {countryCode ? <div>{countryCode}</div> : ''}
            {phone ? <div>{formatPhoneNumber(phone.number)}</div> : ''}
        </>
    );
};

AddressHelper.propTypes = {
    address: PropTypes.object.isRequired,
    phone: PropTypes.object.isRequired,
};

export default AddressHelper;
